module.exports = __webpack_public_path__ + "img/categoria-7.33783b82.png";